import React from "react";

import "assets/css/loading.css"

export default function Spinner(props) {
  return (
    <div className="modal-wrapper">
      <div className="spinner">
        <div className="rect1"></div>
        <div className="rect2"></div>
        <div className="rect3"></div>
        <div className="rect4"></div>
        <div className="rect5"></div>
      </div>
    </div>
  );
};
